import styled from 'styled-components';
import { Spinner } from '@codex/basics';


const SpinnerWrapper = styled.div`
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 2em 0;
`;

const ListingPageLoadingSpinner = () => (
  <SpinnerWrapper>
    <Spinner spin />
  </SpinnerWrapper>
);

export default ListingPageLoadingSpinner;
